"use strict";

var type = require("type-detect");

module.exports = function typeOf(value) {
    return type(value).toLowerCase();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/sinon/lib/sinon/util/core/typeOf.js
// module id = 610
// module chunks = 0